module.exports = __webpack_public_path__ + "img/iso9001.0e37f97.png";